import React from "react";
import DietEstablishmentInfo from "./info/DietEstablishmentInfo";

export const dietEstablishmentSidebarSections = [
  { id: 1, title: "dane założeń", component: <DietEstablishmentInfo /> },
];
